module.exports = __webpack_public_path__ + "img/middleground-scene4.12e64aa9.png";